export const COLUMN_TO_SORT_API_FIELD: Record<string, string> = {
    agentName: 'userFirstName',
    applicantName: 'firstName',
    finalTechnicalOutcome: 'finalTechnicalOutcomeLabel',
    paymentEffectiveDate: 'policyEffectiveDate',
};

export const SORT_ICON_COLORS = {
    active: '#0066cc',
    inactive: '#bfbfbf',
};